/** Parts are clipped from each approved illustration, in its 512 × 768 coordinates.
 * Neck/shoulder overlaps keep the joins covered throughout the small gestures. */
export const mascotPoses = {
  pensando: {
    head: 'M0 0H512V232H352Q316 222 286 240Q268 254 276 279L288 301Q230 326 163 291H0Z',
    gesture: 'M290 235Q337 230 357 282Q396 340 405 405Q410 452 350 499Q318 480 311 441Q319 391 298 342Q275 298 271 270Q272 246 290 235Z',
    gestureName: 'chin',
  },
  animado: {
    head: 'M0 0H310V230L354 257L306 290L255 303Q173 339 92 307H0Z',
    gesture: 'M315 0H490V326L412 362L372 315Q308 191 315 0Z',
    gestureName: 'upright-tail',
    behind: true,
  },
  conferindo: {
    head: 'M0 0H512V251H369L351 284Q272 311 195 282L117 232H0Z',
    gesture: 'M298 254L490 252L413 455L275 461Q169 535 95 500L87 402Q166 340 235 344L271 349Z',
    gestureName: 'checklist',
  },
  concluido: {
    head: 'M0 0H512V281H369Q280 315 171 277H0Z',
    gesture: 'M0 583H128Q136 636 204 644L323 642Q382 642 399 682L401 732L296 748Q242 733 172 731H0Z',
    gestureName: 'resting-tail',
  },
  'pedindo-esclarecimento': {
    head: 'M0 0H512V292H307Q220 322 132 267H0Z',
    gesture: 'M0 382H169Q212 415 183 470L148 594H0Z',
    gestureName: 'offering-paw',
  },
} satisfies Record<string, { head: string; gesture: string; gestureName: string; behind?: boolean }>

export type IllustratedPose = keyof typeof mascotPoses
